export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_PRAZO_RESPOSTA_INICIAL = 'prazoRespostaInicial';
export const SET_PRAZO_RESPOSTA_FINAL = 'prazoRespostaFinal';
export const SET_DATA_ENTRADA_INICIAL = 'dataEntradaInicial';
export const SET_DATA_ENTRADA_FINAL = 'dataEntradaFinal';
export const SET_COMPRADOR = 'comprador';
export const SET_STATUS = 'status';

